import { render, staticRenderFns } from "./StoriesArticleIllustratedMainImgSideCorners.vue?vue&type=template&id=1426baca&scoped=true&"
import script from "./StoriesArticleIllustratedMainImgSideCorners.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainImgSideCorners.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainImgSideCorners.vue?vue&type=style&index=0&id=1426baca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426baca",
  null
  
)

export default component.exports